import * as config from '../../config.js';

/**
 * SteleCharging wraps the Charging-Options selected
 * @constructor  basically for duck-typing of the IDE, but stele-store.js may use it to init it's state.
 */
function SteleCharging() {
	this.count = 0;
	this.type = config.C_TYPE_BASIC;
	this.power = config.C_POWER_3k7;
	this.positioning = 0;
}

export default SteleCharging;
